export const OPEN_MODAL = "OPEN_MODAL"
export const CLOSE_MODAL = "CLOSE_MODAL"
export const ACCOUNTS_FETCH = "ACCOUNTS_FETCH"
export const ACCOUNTS_FETCH_SUCCESS = `${ACCOUNTS_FETCH}_SUCCESS`
export const ACCOUNTS_FETCH_FAILURE = `${ACCOUNTS_FETCH}_FAILURE`
export const ACCOUNTS_FETCH_CALL = `${ACCOUNTS_FETCH}_CALL`
export const SET_ACCOUNT = "SET_ACCOUNT"
export const CLEAR_ACCOUNT = "CLEAR_ACCOUNT"

export const FIRST_STEPS = "FIRST_STEPS"
export const FIRST_STEPS_SUCCESS = `${FIRST_STEPS}_SUCCESS`
export const FIRST_STEPS_FAILURE = `${FIRST_STEPS}_FAILURE`
export const FIRST_STEPS_CALL = `${FIRST_STEPS}_CALL`

export const ACCOUNT_SYSTEM_EVENT = "ACCOUNT_SYSTEM_EVENT"
export const ACCOUNT_SYSTEM_EVENT_SUCCESS = `${ACCOUNT_SYSTEM_EVENT}_SUCCESS`
export const ACCOUNT_SYSTEM_EVENT_FAILURE = `${ACCOUNT_SYSTEM_EVENT}_FAILURE`
export const ACCOUNT_SYSTEM_EVENT_CALL = `${ACCOUNT_SYSTEM_EVENT}_CALL`
export const CLEAR_SYSTEM_EVENTS = "CLEAR_SYSTEM_EVENTS"

export const USER_NAME_UPDATED = "USER_NAME_UPDATED"
export const USER_NAME_UPDATED_ERROR = "USER_NAME_UPDATED_ERROR"
export const USER_NAME_UPDATED_LOADING = "USER_NAME_UPDATED_LOADING"

export const ACCOUNT_BALANCE_DETAILS = "ACCOUNT_BALANCE_DETAILS"
export const ACCOUNT_BALANCE_DETAILS_SUCCESS = `${ACCOUNT_BALANCE_DETAILS}_SUCCESS`
export const ACCOUNT_BALANCE_DETAILS_FAILURE = `${ACCOUNT_BALANCE_DETAILS}_FAILURE`
export const ACCOUNT_BALANCE_DETAILS_CALL = `${ACCOUNT_BALANCE_DETAILS}_CALL`

export const ACCOUNT_BILLINGS = "ACCOUNT_BILLINGS"
export const ACCOUNT_BILLINGS_SUCCESS = `${ACCOUNT_BILLINGS}_SUCCESS`
export const ACCOUNT_BILLINGS_FAILURE = `${ACCOUNT_BILLINGS}_FAILURE`
export const ACCOUNT_BILLINGS_CALL = `${ACCOUNT_BILLINGS}_CALL`

export const ACCOUNT_EVENTS = "ACCOUNT_EVENTS"
export const ACCOUNT_EVENTS_SUCCESS = `${ACCOUNT_EVENTS}_SUCCESS`
export const ACCOUNT_EVENTS_FAILURE = `${ACCOUNT_EVENTS}_FAILURE`
export const ACCOUNT_EVENTS_CALL = `${ACCOUNT_EVENTS}_CALL`
